import React from 'react';
import './Checkout.scss';
import classNames from "classnames";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import CheckoutProgress from "./CheckoutProgress";

import CheckoutParticipants from "./steps/CheckoutParticipants";
import CheckoutRenter from "./steps/CheckoutContact";
import CheckoutSummary from "./steps/CheckoutSummary";
import {CHECKOUT_BUTTON_CONFIG} from "./CheckoutNavigation";

export const CHECKOUT_STEP_PARTICIPANTS = 1;
export const CHECKOUT_STEP_CONTACT = 2;
export const CHECKOUT_STEP_SUMMARY = 3;

function Checkout(props) {

	const classes = classNames(
		'checkout',
		props.additionalClasses
	);

	const maxCheckoutSteps = Object.keys(CHECKOUT_BUTTON_CONFIG).length;

	return (
		<div className={classes}>
			<CheckoutProgress steps={maxCheckoutSteps} currentStep={props.checkoutStep}/>
			{props.checkoutStep === CHECKOUT_STEP_PARTICIPANTS &&
			<CheckoutParticipants parentId={props.parentId} checkoutStep={props.checkoutStep}/>}
			{props.checkoutStep === CHECKOUT_STEP_CONTACT &&
			<CheckoutRenter parentId={props.parentId} checkoutStep={props.checkoutStep}/>}
			{props.checkoutStep === CHECKOUT_STEP_SUMMARY &&
			<CheckoutSummary parentId={props.parentId} checkoutStep={props.checkoutStep}/>}
		</div>
	);
}

Checkout.propTypes = {
	/**
	 * OPTIONAL: add additional classes for this component here.
	 * Use this prop for special css-classes, which are not defined by default.*
	 */
	additionalClasses: PropTypes.string
};

Checkout.defaultProps = {
	hasCheckoutButton: false
};

const mapStateToProps = (state, ownProps) => {
	return {
		checkoutStep: state.checkoutManagement.checkoutState,
	}
};

export default connect(mapStateToProps, {})(Checkout);
